import { ReactNode } from "react";

import { Divider, Accordion, AccordionSummary, AccordionDetails, Typography, Stack } from "@mui/material";
import { ExpandMore } from '@mui/icons-material';

interface SettingsAccordionProps {
  /**
   * Label to be displayed in the UI
   */
  label: string;
  /**
   * List of UI components to be grouped inside THIS accordion
   */
  children?: ReactNode;
  /**
   * Allows user to conditionally display bottom divider.
   * This is useful if the accordion is the last in the list.
   */
  showBottomDivider?: boolean;
}

export default function SettingsAccordion(props: SettingsAccordionProps) {
  return (
    <>
      <Accordion defaultExpanded sx={{ background: "transparent" }}>
        <AccordionSummary
          sx={{
            padding: 0,
            "&.MuiAccordionSummary-root.Mui-expanded": {
              minHeight: "32px",
            },
            "&.MuiButtonBase-root .MuiAccordionSummary-content.Mui-expanded": {
              margin: 0
            }
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography variant="h4">{props.label}</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ paddingLeft: 0, paddingRight: 0 }}>
          <Stack sx={{
            gap: 1
          }}>
            {props.children}
          </Stack>
        </AccordionDetails>
      </Accordion>
      {props.showBottomDivider && <Divider variant="fullWidth" sx={{width: "100%"}} />}
    </>
  );
}